module.exports = __webpack_public_path__ + "img/电梯动画14.0a61e587.png";